const BasicLayout = () => import('./DefaultLayout.vue');
const BlankLayout = () => import('./BlankLayout/index.vue');
const AuthLayout = () => import('./AuthLayout.vue');
const ErrorLayout = () => import('./ErrorLayout.vue');

export { AuthLayout, BasicLayout, BlankLayout, ErrorLayout };
